import * as ACTIONS from "@iso/redux/occasions/actionTypes";

const initialState = {
  occasions: {
    list: [],
    total: 0,
  },
};

function occasionsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_OCCASIONS_SUCCESS: {
      return {
        ...state,
        ...{ occasions: payload },
      };
    }

    default:
      return state;
  }
}

export default occasionsReducer;
